import React, { useEffect } from 'react';
import styles from '../../styles.module.css';
import RateComponent from '@/components/common/RateComponent';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
// import { usePathname } from '@/i18n/navigation';

export default function RatingFilters() {
  const tCommon = useTranslations('common');
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const list = [
    { id: 4, icon: <RateComponent rate={4} />, title: '+4' },
    { id: 3, icon: <RateComponent rate={3} />, title: '+3' },
    { id: 5, icon: <RateComponent rate={5} />, title: tCommon('all') },
  ];
  const locale = useLocale();
  const activeRate = Number(searchParams?.get('rate'));
  // const onClickRate = (item: { id: number }) => {
  //   const params = new URLSearchParams(searchParams.toString());
  //   // params.delete('rate');
  //   params.set('rate', String(item?.id));
  //   params.set('page', '1');
  //   // let localeValue = locale == config.defaultLocale ? '' : `/${locale}`;
  //   router.push(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  // };

  const onClickRate = (item: { id: number }) => {
    const params = new URLSearchParams(searchParams.toString());

    if (activeRate === item.id) {
      // Unselect the current rating
      params.delete('rate');
    } else {
      // Select the new rating
      params.set('rate', String(item.id));
    }

    params.set('page', '1');

    router.push(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  };

  console.log('activeRate====', activeRate);
  return (
    <div className={`${styles.rating_rows}`}>
      {list?.map((item, index) => (
        <div
          key={index}
          className={`${styles.rateItem} ${activeRate == Number(item?.id) && styles.active}`}
          onClick={() => onClickRate(item)}
        >
          {item?.icon}
          <span style={{ direction: 'ltr' }}>{item?.title}</span>
        </div>
      ))}
    </div>
  );
}
